import React, { ReactElement } from 'react';
import {
  Answer,
  CountryArrayQuestionSpec,
  QuestionSpec
  , Nullable,
  ButtonsSettings } from '../../../types/types';
import QuestionBox from "../box";
import QuestionValue from "../value";
import Datearrayfieldviewer from '../../field/viewers/datearrayfieldviewer';
import QuestionLabel from '../label';
import QuestionEditorButton from '../questioneditorbutton';

function DateArrayQuestionViewer(props: {spec: QuestionSpec, answer: Nullable<Answer>, setAnswer?: (answer: Nullable<Answer>) => void, buttonsSettings?: ButtonsSettings, disableInput?: string}): ReactElement {
  const countryArrayQuestionSpec = props.spec as CountryArrayQuestionSpec;
  const setValue = (value: Nullable<Answer['value']>) => {
    if (props.answer && props.setAnswer) {
      props.setAnswer({
        ...props.answer,
        value
      });
    }
  };
  
  return (
    <QuestionBox>
      <QuestionLabel spec={props.spec} />
      <QuestionValue>
        <Datearrayfieldviewer spec={countryArrayQuestionSpec} answer={props.answer} />
      </QuestionValue>
      {props.setAnswer && props.buttonsSettings &&
        <QuestionEditorButton response={props.answer?.value} setResponse={setValue} defaultValue={props.answer?.value} buttonsSettings={props.buttonsSettings} previousAnswer />
      }
    </QuestionBox>
  );
}

export default DateArrayQuestionViewer;
